export default {"src":"/_next/static/media/listing.cfe7a30a.svg","height":398,"width":400};